import { render, staticRenderFns } from "./chat-unread-indicator.vue?vue&type=template&id=4d657069&lang=pug&"
import script from "./chat-unread-indicator.vue?vue&type=script&lang=js&"
export * from "./chat-unread-indicator.vue?vue&type=script&lang=js&"
import style0 from "./chat-unread-indicator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports